import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import SwitchRoutes from '../SwitchRoutes/SwitchRoutes';
import Header from './Header/Header';
import Aside from './Aside/Aside';
import useFirstTimeModals from '../../services/hooks/UI/useFirstTimeModals';
import useBelvo from '../../services/hooks/invoicesIntegration/useBelvo';
import appRoutes from '../../routes';

// Needed here because global behaviour
import { OptionAddCollaborator, OptionAddSuppliers } from '../../components';

import classes from './Platform.module.scss';

const Logged = ({ routes, redirect }) => {
  const [asideIsOpen, setAsideIsOpen] = useState(false);

  useFirstTimeModals();
  useBelvo();

  const { pathname } = useLocation();
  const currentPath = appRoutes.platform.find(({ path }) => pathname === path);
  const currentPathIsFlow = currentPath?.isFlow;

  const asideToggleHandler = () => {
    setAsideIsOpen(prevAsideIsOpen => !prevAsideIsOpen);
  };

  const openToggleHandler = () => {
    setAsideIsOpen(true);
  };

  const containerClasses = [classes.container];
  if (currentPathIsFlow) containerClasses.push(classes['hide-sidebar']);

  return (
    <div id='content-body' className={containerClasses.join(' ')}>
      {!currentPathIsFlow && <Aside openToggleHandler={openToggleHandler} isOpen={asideIsOpen} onAsideToggle={asideToggleHandler} />}
      <Header onHamburger={asideToggleHandler} currentPathIsFlow={currentPathIsFlow} />
      <main>
        <SwitchRoutes routes={routes} redirect={redirect} />
      </main>
      <div id='belvo' />

      {/** Needed here because global behaviour */}
      <OptionAddCollaborator show={false} />
      <OptionAddSuppliers show={false} />
    </div>
  );
};

export default Logged;
